import { Component, OnInit } from '@angular/core';

import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services';

@Component({
  selector: 'app-trad-alert',
  templateUrl: './trad-alert.component.html',
  styleUrls: ['./trad-alert.component.css']
})
export class TradAlertComponent implements OnInit {

  type = "trade";
  type2 = "mytrade";
  public seller_id;
  pageSize = 10;
  pageNo = 1;
  loading: Boolean = true;
  mainLoader;
  searchAlertsList;
  searchAlertsLength;
  user_id;
  lat;
  lng;
  ID;
  allCategories; 
  categoryId = 0;

  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout : 5000
  };

  constructor(private advtService: AdvtService,
              private alertService: AlertService,
  ) { }

  ngOnInit() {
    this.mainLoader = '../../assets/images/BigLoader.gif';

    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.user_id = userInfo.result.id;
      this.lat = userInfo.result.lat;
      this.lng = userInfo.result.lng;
    }
    this.getTradeAlerts(this.user_id);

    this.advtService.getAllCategories().subscribe((data) => {
      this.allCategories = data;
    });
  }

  public _SearchAlertHistory() {
    this.loading = true;
    const limit = this.pageSize;
    const offset = 0;
    this.advtService.getTradeAlerts(this.user_id, limit, offset, this.lat, this.lng,this.categoryId)
      .subscribe(data => {
        this.searchAlertsList = data.result;
        this.searchAlertsLength = data.count;
        this.loading = false;
      }, error => {
        this.alertService.error(error);
      });
  }

  public getTradeAlerts(user_id) {
    this.loading = true;
    const limit = this.pageSize;
    const offset = 0;
    this.advtService.getTradeAlerts(user_id, limit, offset, this.lat, this.lng,this.categoryId)
      .subscribe(data => {
        this.searchAlertsList = data.result;
        this.searchAlertsLength = data.count;
        this.loading = false;


      }, error => {
        this.alertService.error(error);
      });
  }

  pagingAgent(data) {
    this.loading = true;
    this.searchAlertsList = [];
    this.pageNo = (data * this.pageSize) - this.pageSize;
    const limit = this.pageSize;
    const offset = this.pageNo;
    const user_id = this.user_id;

    this.advtService.getSearchAlerts(user_id, limit, offset, this.lat, this.lng,this.categoryId)
      .subscribe(data => {
        window.scrollTo(0, 0);
        this.searchAlertsList = data.result;
        this.searchAlertsLength = data.count;
        this.loading = false;
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/authorized-data/trade/trad-alert/trad-alert.component.ts